import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=310e5e9f&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=310e5e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e5e9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310e5e9f')) {
      api.createRecord('310e5e9f', component.options)
    } else {
      api.reload('310e5e9f', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=310e5e9f&scoped=true&", function () {
      api.rerender('310e5e9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xEawGlC2bVJ3/JS/comp/Voucher.vue"
export default component.exports